import { useRef } from 'react';
import PropTypes from 'prop-types';
import { useTableHeaderRow } from 'react-aria';
import styles from '../TableRow/TableRow.module.scss';

const TableHeaderRow = ({ item, state, children, className, ...props }) => {
    const ref = useRef();
    const { rowProps } = useTableHeaderRow({ node: item }, state, ref);

    return (
        <tr
            className={[
                'govuk-table__row',
                styles.row,
                className
            ].join(' ')}
            {...rowProps}
            ref={ref}
            data-testid={props['data-testid'] ? props['data-testid'] + '.tr' : null}
        >
            {children}
        </tr>
    );
};

TableHeaderRow.propTypes = {
    children: PropTypes.any,
    item: PropTypes.any,
    state: PropTypes.object,
    className: PropTypes.string,
    'data-testid': PropTypes.string
};

export default TableHeaderRow;
